import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useWpItemsList(props) {
  // Use toast
  const toast = useToast()

  const refWpItemListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { label: 'Title', key: 'title', sortable: true },
    { label: 'Category', key: 'category', sortable: true },
    { label: 'Published', key: 'published_at', sortable: true },
    { label: 'Last Updated', key: 'last_imported', sortable: true },
    { label: 'Total Views', key: 'all_analytics_count', sortable: true },
    { label: 'Views (Prev 28 days)', key: 'last_28_days_analytics_count', sortable: true },
    { label: 'Actions', key: 'actions' },
  ]
  const perPage = ref(10)
  const totalWpItems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('last_imported')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)



  const dataMeta = computed(() => {
    const localItemsCount = refWpItemListTable.value ? refWpItemListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalWpItems.value,
    }
  })

  const refetchData = () => {
    refWpItemListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchWpItems = (ctx, callback) => {
    store
      .dispatch('app/listWpItems', {
        contentType: props.contentType,
        queryParams: {
          q: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          status: statusFilter.value,
        },
      })
      .then(response => {
        const { results, total } = response.data

        callback(results)
        totalWpItems.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching content items.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }


  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*



  const resolveWpItemStatusVariant = status => {
    if (status) return 'success'
    if (!status) return 'secondary'
    return 'secondary'
  }

  const statusOptions = [
    { label: 'Draft', value: false },
    { label: 'Published', value: true },
  ]

  return {
    fetchWpItems,
    tableColumns,
    perPage,
    currentPage,
    totalWpItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refWpItemListTable,
    resolveWpItemStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
    statusOptions,
  }
}
